import { useAuthStore } from '@/stores/auth'
import { log } from '@/services/log'

const NAME = 'Authentication Guard'

export default async function (to) {
  const store = useAuthStore()
  const authStatus = store.authStatus

  if (to?.meta?.requiresAuth && authStatus !== 'SUCCESS' && to.path !== '/login') {
    log(NAME, ': Redirecting to login page since the page is protected and user is not yet authenticated.')
    return { path: '/login' }
  }
}
